<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.department') }} > {{ department.name }}
      </BaseTopBarContent>
      <BaseTopBarContent className="right">
        <div
          v-if="!loading"
          class="action">
          <BaseActionDropdown
            v-if="hasRoleDelete"
            :icon="`fas fa-cog`"
            :text="$t('button.options')"
            :items="[
              {
                icon: 'fas fa-trash',
                iconClassName: 'text-danger',
                text: $t('button.delete'),
                textClassName: 'text-danger',
                value: 'delete',
              }
            ]"
            @onSelect="handleSelectOption"
          />
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <HrmDepartmentForm
        :state="department"
        :isSubmitted="isSubmitted"
        :employees="employees"
        :disabled="disabled || !hasRoleEdit"
        :form.sync="form"
        :showActionButtons="hasRoleEdit"
        @onSubmit="handleSubmit"
      />

      <baseConfirmDeleteModal
        :show="modal.show"
        :loading="modal.loading"
        @onClose="handleCloseModal"
        @onCancel="handleCancleModal"
        @onSubmit="handleSumitModal"
      />
      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { toISODateString } from '@/helpers'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      query: {
        id: this.$route.query.id,
        name: this.$route.query.name,
      },
      modal: {
        show: false,
        loading: false,
      },
      form: null,
    }
  },

  computed: {
    ...mapState('hrm', {
      employees: 'employeeList',
      department: 'departmentSingle',
    }),
    ...mapGetters({
      sidebar: 'getSidebar',
    }),
  },

  async created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.hrm.title'),
      current: {
        app_name: 'hrm',
        app_id: 13,
        module_id: 2,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, [{
      'name': this.query.name,
      'router': {
        'name': 'DepartmentEdit',
        'query': {
          id: this.query.id,
          name: this.query.name,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 1,
      submenuAtIdx: 2,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('hrm', {
      getEmployeeList: 'getEmployeeList',
      getDepartmentSingle: 'getDepartmentSingle',
      updateDepartment: 'updateDepartment',
      updateDepartmentAssign: 'updateDepartmentAssign',
      deleteDepartment: 'deleteDepartment',
    }),
    async fetchData () {
      this.loading = true
      const params = { page: 1, limit: 100000 }
      await Promise.all([
        this.getEmployeeList(params),
        this.getDepartmentSingle(this.query.id),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    async handleSubmit ({ name, assignIds = [] }) {
      this.disabled = true
      this.isSubmitted = true
      const responseUpdate = await this.updateDepartment({ id: this.query.id, data: { name } })
      const responseUpdateAssign = await this.updateDepartmentAssign({ id: this.query.id, data: { emp_ids: assignIds } })
      if (responseUpdate.success && responseUpdateAssign.success) {
        this.disabled = false
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: name }),
          color: 'success',
          icon: 'cloud',
        })
        this.fetchData()
      }
    },
    handleSelectOption (value) {
      if (value === 'delete') {
        this.onOpenModal()
      }
    },
    onOpenModal () {
      this.modal.show = true
    },
    handleCloseModal () {
      this.modal.show = false
    },
    handleCancleModal () {
      this.modal.show = false
    },
    async handleSumitModal () {
      this.modal.loading = true
      const response = await this.deleteDepartment(this.query.id)
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.department.name }),
          color: 'danger',
          icon: 'delete',
        })
        this.modal.loading = false
        this.modal.show = false
        this.$router.push({ name: 'DepartmentList' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/hrm/department/Edit.vue